"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _reactVis = require("react-vis");

var _ResizableXYPlot = _interopRequireDefault(require("./ResizableXYPlot"));

var _YAxisArrow = _interopRequireDefault(require("./CustomerSystemHistory/YAxisArrow"));

var _ShadowFilter = _interopRequireDefault(require("./CustomerSystemHistory/ShadowFilter"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var yAxisStyle = {
  line: {
    stroke: 'none'
  },
  text: {
    fill: 'white'
  }
};

var Fixed = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 70px;\n  height: ", ";\n  border-right: 1px solid rgba(0, 0, 0, 0.12);\n  background: white;\n"])), function (props) {
  return props.chartHeight;
});

var Wrap = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 70px;\n  height: ", ";\n  position: absolute;\n  bottom: ", ";\n  z-index: 10;\n"])), function (props) {
  return props.chartHeight;
}, function (props) {
  return props.bottom;
});

var FixedYAxisChart = function FixedYAxisChart(_ref) {
  var handleTickFormat = _ref.handleTickFormat,
      hasNoData = _ref.hasNoData,
      yTickRange = _ref.yTickRange,
      yAxisLabel = _ref.yAxisLabel,
      chartHeight = _ref.chartHeight,
      tickValues = _ref.tickValues,
      bottom = _ref.bottom;
  return /*#__PURE__*/_react["default"].createElement(Wrap, {
    chartHeight: chartHeight,
    bottom: bottom
  }, /*#__PURE__*/_react["default"].createElement(Fixed, {
    chartHeight: chartHeight,
    "data-tour": "data-axis"
  }, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    dontCheckIfEmpty: true,
    width: 70,
    xType: "time",
    xDomain: [0, 1]
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.GradientDefs, null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement(_ShadowFilter["default"], null))), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    data: [{
      x: 0,
      y: yTickRange[0]
    }, {
      x: 1,
      y: yTickRange[1]
    }],
    style: {
      fill: 'none',
      stroke: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.YAxis, {
    left: -80,
    style: yAxisStyle,
    tickFormat: function tickFormat(t) {
      return /*#__PURE__*/_react["default"].createElement(_YAxisArrow["default"], null, handleTickFormat ? handleTickFormat(t) : "".concat(t, " kWh"));
    },
    width: 70,
    tickValues: tickValues
  }), yAxisLabel && !hasNoData && /*#__PURE__*/_react["default"].createElement(_reactVis.ChartLabel, {
    xPercent: 0.42,
    text: yAxisLabel,
    className: "alt-y-axis-label"
  }))));
};

FixedYAxisChart.propTypes = {
  hasNoData: _propTypes["default"].bool,
  handleTickFormat: _propTypes["default"].func,
  chartHeight: _propTypes["default"].string,
  yTickRange: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  tickValues: _propTypes["default"].arrayOf(_propTypes["default"].string),
  yAxisLabel: _propTypes["default"].string,
  bottom: _propTypes["default"].string
};
FixedYAxisChart.defaultProps = {
  hasNoData: false,
  tickValues: undefined,
  chartHeight: '300px',
  handleTickFormat: null,
  yAxisLabel: null,
  bottom: 'unset'
};
var _default = FixedYAxisChart;
exports["default"] = _default;